module.exports = __webpack_public_path__ + "static/img/hh-court.331e415f.png";